export default "__VITE_ASSET__uzR1d$NH__"